// Real 30-day enquiry trend as a line (zero days are valid data points). No smoothing, no fabricated deltas.
export function TrendBars({ points }) {
  if (!points.length) return <p className="text-sm text-jigsaw-muted">No trend data available.</p>;
  const W = 260, H = 110, pad = 6;
  const max = Math.max(1, ...points.map((p) => p.count));
  const x = (i) => pad + (i / (points.length - 1)) * (W - pad * 2);
  const y = (v) => H - pad - (v / max) * (H - pad * 2);
  const d = points.map((p, i) => `${i ? "L" : "M"}${x(i).toFixed(1)},${y(p.count).toFixed(1)}`).join(" ");
  const area = `${d} L${x(points.length - 1).toFixed(1)},${H - pad} L${pad},${H - pad} Z`;
  const fmt = (s) => new Date(s).toLocaleDateString("en-GB", { day: "numeric", month: "short" });
  const total = points.reduce((n, p) => n + p.count, 0);
  return (
    <div>
      <svg data-testid="enquiry-trend-line" viewBox={`0 0 ${W} ${H}`} className="h-[120px] w-full" role="img" aria-label={`${total} enquiries in the last 30 days`}>
        {[0.25, 0.5, 0.75].map((g) => <line key={g} x1={pad} x2={W - pad} y1={y(max * g)} y2={y(max * g)} stroke="#E4E7EC" strokeDasharray="2 3" />)}
        <path d={area} fill="#F28C28" opacity="0.10" />
        <path d={d} fill="none" stroke="#F28C28" strokeWidth="2" strokeLinejoin="round" />
        {points.map((p, i) => p.count > 0 && <circle key={p.date} cx={x(i)} cy={y(p.count)} r="2.5" fill="#F28C28" />)}
      </svg>
      <div className="mt-1 flex justify-between text-[10px] text-jigsaw-muted"><span>{fmt(points[0].date)}</span><span>peak {max}</span><span>{fmt(points[points.length - 1].date)}</span></div>
    </div>
  );
}
